// Shared source chip (plan todo 17). This module is the CANONICAL home of
// the data-source label map — extracted from meal-review/review-utils, which
// re-exports both symbols so existing consumers and tests keep working.
//
// CONTRACT for todo 20 (Today) and any other surface:
// - <SourceChip dataSource={value} testId="..." /> renders the label pill for
//   every KNOWN dataSource and renders NOTHING (null) for undefined or
//   unrecognized values — callers never need a conditional wrapper.
// - Labels and styling are fixed so Meal Review, Food Search, and Today show
//   an identical chip for the same source. Do not fork the styles per screen;
//   extend DATA_SOURCE_LABELS here when a new source kind appears.
//
// Labels (plan todo 17, exact wording): Verified database / Barcode product /
// Nutrition label / AI estimate / User entered / Saved recipe /
// Incomplete nutrition / Memory.

export const DATA_SOURCE_LABELS: Record<string, string> = {
  "verified-database": "Verified database",
  barcode: "Barcode product",
  "nutrition-label": "Nutrition label",
  "ai-estimate": "AI estimate",
  "user-entered": "User entered",
  "saved-recipe": "Saved recipe",
  memory: "Memory",
  incomplete: "Incomplete nutrition",
};

export function dataSourceLabel(dataSource: string | undefined): string | null {
  if (dataSource === undefined) return null;
  return DATA_SOURCE_LABELS[dataSource] ?? null;
}

export interface SourceChipProps {
  readonly dataSource: string | undefined;
  readonly testId?: string;
}

export function SourceChip({ dataSource, testId }: SourceChipProps) {
  const label = dataSourceLabel(dataSource);
  if (label === null) return null;
  return (
    <span
      data-testid={testId}
      className="inline-block rounded-full bg-accent-light px-2 py-0.5 text-[10px] font-semibold text-accent-dark"
    >
      {label}
    </span>
  );
}
